import { ref } from "vue";

export type Notification = {
  id: string;
  message: string;
};

const pendingNotifications: Array<Notification> = [];

export const useNotifications = () => {
  const notifications = ref<Array<Notification>>([]);

  function syncPendingNotifications() {
    notifications.value = pendingNotifications.splice(0);
  }

  const addPendingNotification = (message: string) => {
    pendingNotifications.push({ id: crypto.randomUUID(), message });
  };

  const acknowledgeNotification = (id: string) => {
    notifications.value = notifications.value.filter(
      (notification) => notification.id !== id,
    );
  };

  return {
    notifications,
    acknowledgeNotification,
    addPendingNotification,
    syncPendingNotifications,
  };
};
